import { localizeText } from "src/localization/utils"
import { SortValue } from "./types"

export function getLocalizedSortOptions() {
  const T = localizeText(text)

  return [
    { value: "relevance", label: T.relevance },
    { value: "created_at", label: T.createdAt },
    { value: "price_asc", label: T.priceAsc },
    { value: "price_desc", label: T.priceDesc },
  ] satisfies { value: SortValue; label: string }[]
}

const de = {
  relevance: "Relevanz",
  createdAt: "Neueste zuerst",
  priceAsc: "Preis aufsteigend",
  priceDesc: "Preis absteigend",
}

const en: typeof de = {
  relevance: "Relevance",
  createdAt: "Newest first",
  priceAsc: "Price ascending",
  priceDesc: "Price descending",
}

const text = { de, en }
